import Vue from 'vue';
import {HTTPCODES} from '../../plugins/types';
/**
 * @module Store/banners
 * @description Module for banners
 */

/**
 * @constant State of banners
 * @type {object}
 * */
const state = {
    banner: {
        ammount: 0,
        timer: 1000, 
        slides: []
    },
    languages: {}
};

/**
 * @constant Getters
 * @type {object}
 * */
const getters = {
    getBanner: state => state.banner,
    getLanguages: state => state.languages,
};

/**
 * @constant Mutations
 * @type {object}
 * */
const mutations = {
    updateBanner: (state, banner) => state.banner = banner,
    updateLanguages: (state, languages) => state.languages = languages,
};

/**
 * @constant Actions
 * @type {object}

 * */
const actions = {
    async getLanguagesAsync ({commit, rootState}) {
        try {
            let {data} = await Vue.axios.get(`${rootState.config.utilities}/`);

            let obj = {}
            data.forEach(el => {
                obj[el] = ""
            })
            commit('updateLanguages', obj)
            return data;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'get languages'
            });
            return rootState.banners.languages
        }
    },
    async getBannerAsync ({commit, rootState}) {
        try {
            let {data} = await Vue.axios.get(`${rootState.config.utilities}/start/notification`);
            commit('updateBanner', data)
            return data;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            return rootState.banners.banner
        }
    },
    async setBannerAsync({commit, rootState}, payload){
        try {
            let {data} = await Vue.axios.post(`${rootState.config.utilities}/start/notification`, payload);
            commit('addAlert', {
                title: 'Success ',
                type: 'success',
                body: 'update banner'
            });
            return data;
        } catch (err) {
            if(err.response && err.response.status >= 400) {
                if(err.response.status === 401) {
                    return {err: HTTPCODES[err.response.status]};
                }
            }
            commit('addAlert', {
                title: 'Failed ',
                type: 'danger',
                body: 'set banner collection'
            });
            throw new Error(err);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
